export default class usersPermissionsUser {
	constructor() {
		this.username = null
		this.email = null
		this.provider = null
		this.id = null
	}
}